import * as React from "react";
import type { SVGProps } from "react";
const SvgScanIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="scan_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M213.333 85.333a128 128 0 0 0-128 128v128a42.667 42.667 0 0 0 85.334 0v-128a42.667 42.667 0 0 1 42.666-42.666h128a42.667 42.667 0 0 0 0-85.334h-128zm469.334 0a42.667 42.667 0 1 0 0 85.334h128a42.667 42.667 0 0 1 42.666 42.666v128a42.667 42.667 0 1 0 85.334 0v-128a128 128 0 0 0-128-128h-128zm-512 597.334a42.667 42.667 0 1 0-85.334 0v128a128 128 0 0 0 128 128h128a42.667 42.667 0 1 0 0-85.334h-128a42.667 42.667 0 0 1-42.666-42.666v-128zm768 0a42.667 42.667 0 1 0-85.334 0v128a42.667 42.667 0 0 1-42.666 42.666h-128a42.667 42.667 0 1 0 0 85.334h128a128 128 0 0 0 128-128v-128zM128 469.333a42.667 42.667 0 1 0 0 85.334h768a42.667 42.667 0 1 0 0-85.334H128z"
    />
  </svg>
);
export default SvgScanIcon;
